import { postJson } from "@/ajax/http";
import { ContentManageApiUrl, SiteCode } from "@/config/sys.config";

export const cmApi = {
    getInheritValue: (data) => {
        const url = ContentManageApiUrl + '/config-item/value/getInheritValue'
        return postJson(url, data);
    },
    getPublicConfig: ({ pageId, pageCode }) => {
        return cmApi.getInheritValue({ pageId, pageCode, moduleCode: 'ZNWD_PAGE_CONFIG', siteCode: SiteCode });
    }
}
